<template>
    <form v-if="ready" @shown="focusMyElement" @submit.prevent="store" @keydown="form.errors.clear($event.target.name)">
        <form-input labelClasses="col-md-9 col-xl-3 col-sm-12" inputHolderClasses="col-xl-9" :form="form" type="text" name="name" required/>
        <form-textarea labelClasses="col-md-9 col-xl-3 col-sm-12" inputHolderClasses="col-xl-9" name="description" rows="6" :form="form"/>

        <backend-select
            labelClasses="col-md-9 col-xl-3 col-sm-12"
            :error="form.errors.get('address_type_id')"
            required
            inputHolderClasses="col-xl-9"
            return="id"
            track-by="id"
            :value="form.address_type_id"
            v-model="form.address_type_id"
            object-name-key="value"
            name="address_type_id"
            label="type"
            :route="route('settings.values.index', { setting: 1 })"
            @input="form.errors.clear('address_type_id')"
        />

        <backend-select
            labelClasses="col-md-9 col-xl-3 col-sm-12"
            :error="form.errors.get('country')"
            required
            country
            inputHolderClasses="col-xl-9"
            return="iso_3166_2"
            valueKey="iso_3166_2"
            :value="field('country')"
            v-model="form.country"
            name="country"
            label="country"
            :route="route('admin.countries.index')"
            @input="validateAddress"
        />
        <form-input labelClasses="col-md-9 col-xl-3 col-sm-12" inputHolderClasses="col-xl-9" :form="form" required
                    name="zipcode" ref="focusThis" @blur="validateAddress"/>
        <form-input labelClasses="col-md-9 col-xl-3 col-sm-12" inputHolderClasses="col-xl-9" :form="form" required
                    name="house_number" @blur="validateAddress" @keydown="deleteErrorFromZipcode"/>
        <form-input labelClasses="col-md-9 col-xl-3 col-sm-12" inputHolderClasses="col-xl-9" :form="form" required
                    name="street" :readonly="!this.invalidAddress" :loading="retrievingAddress"/>
        <form-input labelClasses="col-md-9 col-xl-3 col-sm-12" inputHolderClasses="col-xl-9" :form="form" required
                    name="city" :readonly="!this.invalidAddress" :loading="retrievingAddress"/>

        <div class="form-group">
            <input :disabled="form.busy" type="submit" :value="uLang('app.save')" class="btn btn-done" />
        </div>
    </form>
</template>
<script>
    import Form from '~/Form/Form'
    import FormMixin from '~/mixins/form'

    export default {
        name: "form-address",
        mixins: [FormMixin],

        props: {
            overrideEndpoint: {
                type: String,
                required: true,
            },
            id: {
                required: false,
            },
        },

        data(){
            return {
                form: new Form({
                    name: '',
                    description: '',
                    address_type_id: null,
                    street: '',
                    house_number: '',
                    zipcode: '',
                    city: '',
                    country: 'NL',
                }),
                entity: 'location',
                invalidAddress: true,
                lastRequestedWith: {
                    zipcode: null,
                    house_number: null,
                },
                retrievingAddress: false,
            }
        },

        mounted: function() {
            this.$on('afterStore', this.locationStored);
            this.$on('afterUpdate', this.locationUpdated);
            this.$on('afterRetrieve', this.locationRetrieved);
        },

        methods: {
            locationStored(location) {
                this.$emit('locationStored', location)
            },

            locationUpdated(location) {
                this.$emit('locationUpdated', location)
            },

            locationRetrieved(data) {
                if (data.country !== null && typeof data.country === 'object') {
                    this.form.originalData['country'] = data.country.iso_3166_2;
                    this.form['country'] = data.country.iso_3166_2;
                }
            },

            focusMyElement(e) {
                this.$refs.focusThis.focus();
            },

            async validateAddress() {
                this.form.errors.clear('country');

                // Make zipcode uppercase and remove spaces.
                this.form.zipcode = this.form.zipcode.replace(/\s+/g, '').toUpperCase();

                if(this.form.country === 'NL' && (this.form.zipcode.length >= 6 && this.form.zipcode.length <= 7) && this.form.house_number.length > 0) {

                    if (this.lastRequestedWith.zipcode === this.form.zipcode && this.lastRequestedWith.house_number === this.form.house_number) {
                        return;
                    }

                    this.lastRequestedWith.zipcode = this.form.zipcode;
                    this.lastRequestedWith.house_number = this.form.house_number;

                    this.retrievingAddress = true;

                    window.axios.get('/api/addresses/data/' + this.form.zipcode + '/' + this.form.house_number)
                        .then((response) => {
                            this.invalidAddress = false;

                            this.form.street = response.data.street;
                            this.form.city = response.data.city;

                            this.retrievingAddress = false;
                        })
                        .catch((error) => {
                            this.invalidAddress = true;

                            if (error.response.status === 422) {
                                this.form.errors.record(error.response.data.errors);
                            }

                            this.form.street = '';
                            this.form.city = '';

                            this.retrievingAddress = false;
                        });
                }
            },

            deleteErrorFromZipcode() {
                this.form.errors.clear('zipcode');
            }
        }
    }
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped>
    .failed-input {
        color: #fd7570
    }
</style>
